import {
	CreateBase,
	Form,
	Toolbar,
	useGetIdentity,
	useTranslate
} from 'react-admin';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { ICONS_BY_OBJECT, OBJECTS_TYPES } from '../../../constants';
import { ComplexType } from '../../../types';
import { ComplexInputs } from '../ComplexInputs';

export const ComplexCreate = () => {
	const { identity } = useGetIdentity();
	const translate = useTranslate();

	const Icon = ICONS_BY_OBJECT[OBJECTS_TYPES.COMPLEXES];

	return (
		<Box mt={3}>
			<GoToListButton />
			<CreateBase
				resource={OBJECTS_TYPES.COMPLEXES}
				redirect={() => `objects/${OBJECTS_TYPES.COMPLEXES}`}
				transform={(data): ComplexType => ({
					...data
				})}
			>
				<Box mt={2} display="flex">
					<Box flex="1">
						<Stack mb={1} direction="row" alignItems="center">
							<Icon fontSize="large" />
							<Typography ml={1} variant="h4">
								{translate('objects.items.complex')}
							</Typography>
						</Stack>
						<Form defaultValues={{ sales_id: identity?.id }}>
							<Card>
								<CardContent>
									<ComplexInputs />
								</CardContent>
								<Toolbar />
							</Card>
						</Form>
					</Box>
				</Box>
			</CreateBase>
		</Box>
	);
};
